<div class="batches-index-header">
  <div class="batches-index-header-block">
    <span class="batches-index-header-title">{{
      'BATCH_MAILING.TITLE' | translate
    }}</span>
    <a
      target="_blank"
      aria-labelledby="batch-mailing-title"
      href="https://belpost.by/biznesu/Drugiyeuslugi/Oformleniyepartionnykhpoc"
    >
      {{ 'BATCH_MAILING.LINK_TO_RECOMMENDATIONS' | translate }}
    </a>
  </div>

  <a
    class="button button--sm button--filled button--shadow"
    (click)="createInvoice()"
  >
    {{ 'BATCH_MAILING.RECEIPTS_TAB.CREATE_RECEIPT' | translate }}
  </a>
  <app-main-tabs></app-main-tabs>
</div>

<app-filters
  (removeChange)="removeInvoices()"
  [selected]="selected"
  (searchChange)="search($event)"
></app-filters>
@if (!isLoading) {
  @if (items?.data?.length) {
    <app-paginator
      [items]="items"
      [localStorageKey]="'batch_items_per_page'"
      [pageSizeItemKey]="'BATCH_MAILING.RECEIPTS_TAB.PAGINATION_ITEM_KEY'"
      (pageChange)="pageChanged($event)"
    >
    </app-paginator>
    @for (item of items.data; track item) {
      <section class="batches-index-main">
        <app-invoice-item
          [item]="item"
          (selected)="updateSelection()"
        ></app-invoice-item>
      </section>
    }
  } @else {
    <div class="item-placeholder text-center">
      <img src="./assets/img/misc/box.svg" alt="" class="eye-d-none" />
      <p class="text-secondary">
        {{ 'BATCH_MAILING.RECEIPTS_TAB.NO_RECEIPTS_FOUND' | translate }}
      </p>
    </div>
  }
}

@if (isLoading) {
  <div class="text-secondary text-center">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">{{ 'LOADING' | translate }}</span>
    </div>
  </div>
}
